import React, { forwardRef } from 'react'
import { makeStyles } from '@material-ui/core'
import QtyNumberInput, {
  QtyNumberInputProps
} from '@modules/order/components/CellTemplates/components/QtyNumberInput/QtyNumberInput'

export interface SizedQuantityProps extends QtyNumberInputProps {}
const useStyles = makeStyles(theme => ({
  sizeWrapper: {
    height: 32,
    display: 'flex',
    alignItems: 'center'
  }
}))

const EnhancedSizedQuantity = forwardRef<HTMLInputElement, SizedQuantityProps>(
  ({ ...props }, ref) => {
    const classes = useStyles()
    return (
      <div className={classes.sizeWrapper}>
        <QtyNumberInput {...props} ref={ref} />
      </div>
    )
  }
)

export default EnhancedSizedQuantity
